<template>
  <div class="text-foreground bg-background flex min-h-svh flex-col">
    <header class="border-border/70 bg-background/85 sticky top-0 z-40 border-b backdrop-blur">
      <div class="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-6">
        <RouterLink to="/" class="shrink-0" aria-label="InforceIQ Home">
          <img
            src="/assets/inforceiq-logo-horizontal.svg"
            alt="InforceIQ"
            class="h-9 w-auto sm:h-10"
          />
        </RouterLink>

        <div class="flex items-center gap-3 text-sm">
          <a
            :href="signinHref"
            class="text-muted-foreground hover:text-foreground font-medium transition-colors"
          >
            Sign In
          </a>
        </div>
      </div>
    </header>

    <main class="flex-1">
      <RouterView />
    </main>

    <footer class="border-border/70 border-t">
      <div
        class="mx-auto flex max-w-6xl flex-col gap-5 px-6 py-10 md:flex-row md:items-end md:justify-between"
      >
        <div>
          <img src="/assets/inforceiq-logo-horizontal.svg" alt="InforceIQ" class="h-9 w-auto" />
        </div>
        <div class="flex flex-col gap-4 md:items-end">
          <nav class="flex flex-wrap gap-x-5 gap-y-2 text-sm" aria-label="Footer">
            <RouterLink
              v-for="item in footerNavItems"
              :key="item.to"
              :to="item.to"
              class="text-muted-foreground hover:text-foreground transition-colors"
            >
              {{ item.label }}
            </RouterLink>
          </nav>
          <p class="text-muted-foreground text-xs">
            &copy; {{ year }} InforceIQ. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router'

const footerNavItems = [
  { label: 'Security', to: '/security' },
  { label: 'ACORD', to: '/acord' },
  { label: 'Terms', to: '/terms' },
  { label: 'Privacy', to: '/privacy' },
]

const appBaseUrl = (() => {
  const configured = String((import.meta as any).env?.VITE_APP_URL || '')
    .trim()
    .replace(/\/+$/, '')
  if (configured) return configured
  if (import.meta.env.DEV) return 'http://localhost:5173'
  return 'https://app.inforceiq.com'
})()

const signinHref = `${appBaseUrl}/signin`
const year = new Date().getFullYear()
</script>
